class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    onLibReady(['vue', 'swiper'], this.#init.bind(this));
  }

  async #init() {
    if (!Shopify.recentlyViewed) {
      return;
    }

    const products = await Shopify.recentlyViewed.getRecentlyViewed();
    const availableProducts = products.filter(p => p.variants[0].available);

    if (!availableProducts.length) {
      return;
    }

    new Vue({
      el: this,
      data: {
        products: availableProducts,
        addingToCart: null,
      },
      template: `
        <div class="recently-viewed section">
          <h2 class="section-title">Recently Viewed</h2>
          <div class="recently-viewed__slider">
            <div class="swiper-container" ref="slider">
              <div class="swiper-wrapper">
                <template v-for="product in products">
                  <div class="swiper-slide" :key="product.id">
                    <div class="recently-viewed__product">
                      <a :href="Shopify.routes.root + 'products/' + product.handle" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"></a>

                      <div class="recently-viewed__product-img">
                        <img 
                          :srcset="formatImage(product.variants[0].featured_image, '150x150')" 
                          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                          loading="lazy"
                          alt=""
                          width="150"
                          height="150"
                        >
                      </div>
                      
                      <div class="recently-viewed__product-information">
                        <p class="recently-viewed__product-title">
                          {{ product.variants[0].full_title }}
                        </p>
                        
                        <span class="recently-viewed__product-price" v-html="formatMoney(product.variants[0].price)" />
                        
                        <button
                          class="button button--orange"
                          :class="{'loading': addingToCart === product.variants[0].id}"
                          @click.prevent="handleAddToCart(product.variants[0])"
                          aria-label="Add to cart"
                          v-html="window.Shopify.icons.bag"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div class="slider-scrollbar" ref="sliderScrollbar"></div>
            </div>
  
            <div class="slider-button-prev" ref="sliderBtnPrev" v-html="Shopify.icons.arrowPrev" />
            <div class="slider-button-next" ref="sliderBtnNext" v-html="Shopify.icons.arrowNext" />
          </div>
        </div>
      `,

      async mounted() {
        this.initSlider();
      },

      methods: {
        initSlider() {
          new Swiper(this.$refs.slider, {
            speed: 500,
            slidesPerView: 'auto',
            observer: true,
            watchOverflow: true,
            navigation: {
              nextEl: this.$refs.sliderBtnNext,
              prevEl: this.$refs.sliderBtnPrev,
            },
            scrollbar: {
              el: this.$refs.sliderScrollbar,
              draggable: true,
            },
          });
        },

        handleAddToCart(variant) {
          if (this.addingToCart) return;
          this.addingToCart = variant.id;

          window.cartDrawer
            .add({
              items: [
                {
                  id: variant.id,
                  quantity: 1,
                  properties: {
                    DETAILS: getDetails(variant),
                  },
                },
              ],
            })
            .then(() => {
              this.addingToCart = null;
            });
        },
      },
    });
  }
}

customElements.define('recently-viewed', RecentlyViewed);
